import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'rating-bar',
  templateUrl: './rating-bar.component.html',
  styleUrls: ['./rating-bar.component.scss']
})
export class RatingBarComponent implements OnInit, OnChanges {
  @Input()
  percentage: number;

  cssClass: string;

  constructor() {}

  ngOnInit() {
    this.cssClass = this.getCssClass();
  }

  ngOnChanges(changes: any) {
    if (changes.percentage) {
      this.cssClass = this.getCssClass();
    }
  }

  private getCssClass() {
    return this.percentage >= 66 ? 'high' : this.percentage >= 33 ? 'medium' : 'low';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/rating-bar/rating-bar.component.ts